export default "__VITE_ASSET__CBpFDxxP__"